import './styles.scss'

import React, { useEffect, useState } from 'react'

import { apiPayment } from 'api'
import OrderContainer from './OrderContainer'
import { I18n } from 'react-redux-i18n'
import Nixi1Spinner from 'components/Nixi1Spinner'

const limit = 20

/**
 *
 * @param {object} props
 * @param {Function} props.setActionSelected
 * @param {Function} props.setIdOrderSelected
 * @param {Function} props.setStateInfo
 * @param {Function} props.filterSelected
 * @returns
 */
const Payments = (props) => {
  const { userId, setActionSelected, setIdOrderSelected, setStateInfo, filterSelected } = props

  const [isLoading, setIsLoading] = useState(true)
  const [orders, setOrders] = useState([])
  const [page, setPage] = useState(0)
  const [newOrdersNumber, setNewOrdersNumber] = useState(0)
  const [states, setStates] = useState([])

  useEffect(() => {
    if(filterSelected === 'show_all'){
      setStates([])
    }else{
      setStates([filterSelected])
    }
  }, [filterSelected])

  useEffect(() => {
    setPage(0)
    getOrders(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [states, userId])

  const getOrders = async (isNew=false, pageOrders=0) => {
    try {
      setIsLoading(true)
      const result = await apiPayment.getAllOrders({
        userId: userId,
        page: pageOrders,
        limit,
        sort: 'desc',
        states: states,
      })
      setNewOrdersNumber(result.data.length)
      if (isNew) {
        setOrders(result.data || [])
      } else {
        setOrders([...orders, ...result.data])
      }
      setIsLoading(false)
    } catch (error) {
      setOrders([])
      setIsLoading(false)
    }

  }

  return (
    <div className="container-orders">
      {orders?.map((order) => (
        <OrderContainer
          key={order.id}
          order={order}
          setActionSelected={setActionSelected}
          setIdOrderSelected={setIdOrderSelected}
          setStateInfo={setStateInfo}
        />
      ))}
      {isLoading ? (
        <div style={{ paddingTop: '15px' }}>
          <Nixi1Spinner height='40px' width='98%'  />
        </div>
      ) : !orders.length ? (
        <div className="item-container-orders">
          <div className="data-container-orders">
            <div className="title file-title-no-orders">
              {I18n.t('plugins-Refund-noOrders-history')}
            </div>
          </div>
        </div>
      ) : null}
      {orders.length > 0 && newOrdersNumber === limit ?
        <div className='wrapper-load-more'>
          <span className='text-load-more' onClick={() => {
            setPage(page + 1)
            getOrders(false, page + 1)
          }}>
            <li className='fa fa-refresh' />
            {I18n.t('dashboard_load-more')}
          </span>
        </div>
        :null}
    </div>
  )
}

export default Payments
